import { useEffect, useState } from 'react'
import { api, type StoreRecoEntry } from '../services/api'

/**
 * #8 おすすめ店舗スコア (実利用データ由来) を取得する。
 *
 * 未集計・API エラー時は空 map のまま = 呼び側 (店舗一覧 / Home) は従来の
 * 並びで表示を続ける (backend の fallback 原則に合わせ、失敗を UI に出さない)。
 */
export function useStoreReco() {
  const [scores, setScores] = useState<Record<string, StoreRecoEntry>>({})
  useEffect(() => {
    let cancelled = false
    api.getStoreRecommendations()
      .then((data) => {
        if (!cancelled && data.scores) setScores(data.scores)
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])
  return { scores, recoAvailable: Object.keys(scores).length > 0 }
}
